var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{class:(_vm.hasError ? 'has-error': '', _vm.$i18n.locale === 'ar' ? 'arabic-text' : ''),attrs:{"type":_vm.fieldType,"placeholder":_vm.placeholder,"required":_vm.isRequiredValue,"disabled":_vm.isDisabled},domProps:{"value":_vm.modelValue},on:{"input":function($event){return _vm.$emit('update:modelValue', $event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }